import { useMutation } from '@tanstack/react-query';

import type { QuizMembersChangePayload } from './quizService';

import { QuizService } from './quizService';

export function useEditQuizMemberChanges() {
  return useMutation({
    mutationFn: (data: QuizMembersChangePayload & { id: string }) => {
      return QuizService.editQuizMembers(data.id, {
        memberChanges: data.memberChanges,
      }).then((response) => response.data);
    },
  });
}
